<template>
    <div
        class="view-invoice container"
        :class="{
            'p-4' : isStandalone,
            'p-3 backend' : !isStandalone
        }"
    >
        <googleRecaptcha v-if="isStandalone" ref="googleRecaptcha" @scriptLoaded="googleScriptLoaded" />
        <template v-if="loaded">
            <div class="row gx-3">
                <div class="col-lg-12 col-xl-9">
                    <div class="card shadow-sm invoice-preview-card">
                        <div class="card-body">
                            <div
                                class="invoice-header">
                                <div class="ih-brand">
                                    <div class="d-flex svg-illustration align-items-center">
                                    <span class="app-brand-logo">
                                        <img :src="logo" alt="Logo" height="30">
                                    </span>
                                        <span
                                            class="app-brand-text fw-bold fs-4 ms-0"
                                            :style="(shortNameColor?'color:'+shortNameColor:'')"
                                        >
                                        {{ shortName }}
                                    </span>
                                    </div>
                                    <p class="comp-name"><strong>Dream Tours and Incentives Management Pty Ltd (DTIM)</strong></p>
                                    <p class="address">18 Coolabah Crescent, Hoppers Crossing, VIC 3029, Australia.</p>
                                    <p class="phone-wa"><span>TA License :</span> TA-0033112, <span>Tel:</span> +61 3 9931 0350 (24 hrs)</p>
                                    <p class="email"><span>Whatsapp:</span> +61 414 481 388 (24 hrs), <span>Email:</span> booking@dreamtours.travel</p>
                                </div>
                                <div class="ih-number">
                                    <h4 class="fw-medium mb-2">INVOICE <strong>#{{ invoiceItems.number }}</strong></h4>
                                    <div class="">
                                        <span>Date Issues: </span>
                                        <span class="fw-medium">{{ invoiceItems.issues_date }}</span>
                                    </div>
                                    <div class="">
                                        <span>Date Due: </span>
                                        <span class="fw-medium">{{ invoiceItems.due_date }}</span>
                                    </div>
                                    <div class="pt-2">
                                        <h5 class="mb-0">
                                            <span
                                                class="badge"
                                                :class="{
                                                    'text-bg-primary': ['Pending', 'Confirmed'].includes(invoiceItems.status),
                                                    'text-bg-secondary': ['Cancelled', 'Pipeline'].includes(invoiceItems.status),
                                                    'text-bg-success': invoiceItems.status === 'Paid',
                                                    'text-bg-danger': invoiceItems.status === 'Overdue',
                                                    'text-bg-warning': ['Refunded', 'Overpaid'].includes(invoiceItems.status),
                                                    'text-bg-info': invoiceItems.status === 'Underpaid'
                                                }"
                                            >
                                                {{ invoiceItems.status }}
                                            </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="my-0" />
                        <div class="card-body">
                            <div class="invoice-recipient">
                                <div class="ir-recipient">
                                    <h6 class="mb-3"><strong>Invoice To:</strong></h6>
                                    <p class="name"><strong>{{ invoiceItems.name }}</strong></p>
                                    <p v-if="invoiceItems.company" class="comp-name"><strong>{{ invoiceItems.company }}</strong></p>
                                    <p v-if="invoiceItems.address" class="address">{{ invoiceItems.address }}</p>
                                    <p v-if="invoiceItems.phone" class="phone-wa">
                                        <span>Tel:</span> {{ invoiceItems.phone }}<template v-if="invoiceItems.whatapp"> , <span>WhatApp:</span> {{ invoiceItems.whatapp }}</template>
                                    </p>
                                    <p v-if="invoiceItems.email" class="email"><span>Email:</span> {{ invoiceItems.email }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="border-top">
                            <table class="table items-list">
                                <thead>
                                <tr>
                                    <th>Description</th>
                                    <th class="text-end">PRICE</th>
                                    <th class="text-end">Qty</th>
                                    <th class="text-end" :class="{'pe-4':isStandalone}" >TOTAL</th>
                                    <th class="d-none"></th>
                                </tr>
                                </thead>
                                <tbody>
                                    <template v-for="item in invoiceItems.items || []">
                                        <tr :class="{'item-cancelled': isItemCancelled(item)}">
                                            <td :colspan="invoiceItems.items.length > 1 ? '3' : '5'">
                                                <div>
                                                    <div class="item-destination">{{ item.destinations }}</div>
                                                    <div class="item-name">{{ item.name }}</div>
                                                    <div v-if="item.description" class="item-description">{{ item.description }}</div>
                                                    <div v-if="item.sub_description && !Array.isArray(item.sub_description)" class="item-sub-desc">{{ item.sub_description }}</div>
                                                    <div v-else-if="item.sub_description && Array.isArray(item.sub_description) && item.sub_description.length" class="item-sub-desc">
                                                        <template v-if="item.notes && Array.isArray(item.notes) && item.notes.length" v-for="note in item.notes">
                                                            <span v-if="note"> {{ note }}</span>
                                                        </template>
                                                        <template v-for="sub_desc in item.sub_description">
                                                            <span v-if="sub_desc"> {{ sub_desc }}</span>
                                                        </template>
                                                    </div>
                                                    <div v-if="!(item.sub_description && Array.isArray(item.sub_description) && item.sub_description.length) && item.notes && Array.isArray(item.notes) && item.notes.length" class="item-sub-desc">
                                                        <template v-for="note in item.notes">
                                                            <span v-if="note"> {{ note }}</span>
                                                        </template>
                                                    </div>
                                                </div>
                                                <div v-if="item.promocode && invoiceItems.items.length > 1" class="text-danger">
                                                    Promo Code ({{ item.promocode }})
                                                </div>
                                            </td>
                                            <td v-if="invoiceItems.items.length > 1" class="align-middle text-end" :class="{'pe-4':isStandalone}" style="line-height: 1.2">
                                                <div v-if="item.promocode" class="small">{{ formatPrice(item.price, item.currency.symbol) }}</div>
                                                <div v-if="item.promocode" class="small text-secondary">-{{ formatPrice(item.discount, item.currency.symbol) }}</div>
                                                <div class="item-total">{{ formatPrice(item.promocode ? item.discount_price : item.price, item.currency.symbol) }}</div>
                                            </td>
                                            <td v-if="invoiceItems.items.length > 1" class="d-none"></td>
                                        </tr>
                                        <tr
                                            v-if="hasItems(item)"
                                            v-for="sub_item in item.items || []"
                                            :class="{'item-cancelled': isItemCancelled(item)}"
                                        >
                                            <td>
                                                <div>
                                                    <div class="item-name fw-normal">{{ sub_item.label }}</div>
                                                </div>
                                            </td>
                                            <td class="align-middle">
                                                <div class="item-price fw-normal">
                                                    {{ formatPrice(sub_item.price, item.currency.symbol) }}
                                                </div>
                                            </td>
                                            <td class="align-middle">
                                                <div class="item-quantity fw-normal">
                                                    {{ sub_item.total }}
                                                </div>
                                            </td>
                                            <td class="align-middle" :class="{'pe-4':isStandalone}">
                                                <div class="item-price fw-normal">
                                                    {{ formatPrice(sub_item.total_price, item.currency.symbol) }}
                                                </div>
                                            </td>
                                            <td class="d-none"></td>
                                        </tr>
                                        <tr v-if="hasPickup(item)" :class="{'item-cancelled': isItemCancelled(item)}">
                                            <td>
                                                <div>
                                                    <div class="item-destination">Pickup Location</div>
                                                    <div class="item-name fw-normal" v-if="(isReturnDifferentDay(item) || isDepartureTicket(item) || isReturnDifferentDPTP(item)) && isHasReturnPickup(item)">
                                                        <i>{{ (isReturnDifferentDay(item) || isReturnDifferentDPTP(item) ? `(${item.departureDate}) ` : '') + item.pickup.label }}</i>
                                                        <span class="px-1 text-primary"><i>to</i></span>
                                                        <i>{{ item.returnPickup.name }}</i>
                                                    </div>
                                                    <div v-else class="item-name fw-normal">{{ item.pickup.label }}</div>
                                                    <div v-if="locationServiceInfo(item.pickup.service_info)" class="item-sub-desc" v-html="locationServiceInfo(item.pickup.service_info)" />
                                                </div>
                                            </td>
                                            <td class="align-middle">
                                                <div class="item-price fw-normal">-</div>
                                            </td>
                                            <td class="align-middle">
                                                <div class="item-quantity fw-normal">-</div>
                                            </td>
                                            <td class="align-middle" :class="{'pe-4':isStandalone}">
                                                <div class="item-price fw-normal">
                                                    {{ formatPrice(item.pickup.total_price, item.currency.symbol) }}
                                                </div>
                                            </td>
                                            <td class="d-none"></td>
                                        </tr>
                                        <tr v-if="hasDropOff(item)" :class="{'item-cancelled': isItemCancelled(item)}">
                                            <td>
                                                <div>
                                                    <div class="item-destination">Drop Off Location</div>
                                                    <div class="item-name fw-normal" v-if="(isReturnDifferentDay(item) || isReturnTicket(item) || isReturnDifferentDPTP(item)) && isHasReturnPickup(item)">
                                                        <i>{{ (isReturnDifferentDay(item) || isReturnDifferentDPTP(item) ? `(${item.returnDate}) ` : '') + item.returnPickup.name }}</i>
                                                        <span class="px-1 text-primary"><i>to</i></span>
                                                        <i>{{ item.dropOff.label }}</i>
                                                    </div>
                                                    <div v-else class="item-name fw-normal">{{ item.dropOff.label }}</div>
                                                    <div v-if="locationServiceInfo(item.dropOff.service_info)" class="item-sub-desc" v-html="locationServiceInfo(item.dropOff.service_info)" />
                                                </div>
                                            </td>
                                            <td class="align-middle">
                                                <div class="item-price fw-normal">-</div>
                                            </td>
                                            <td class="align-middle">
                                                <div class="item-quantity fw-normal">-</div>
                                            </td>
                                            <td class="align-middle" :class="{'pe-4':isStandalone}">
                                                <div class="item-price fw-normal">
                                                    {{ formatPrice(item.dropOff.total_price, item.currency.symbol) }}
                                                </div>
                                            </td>
                                            <td class="d-none"></td>
                                        </tr>
                                        <template v-if="hasAddons(item)">
                                            <tr :class="{'item-cancelled': isItemCancelled(item)}">
                                                <td colspan="5" class="align-middle"><div class="item-total text-start">ADD ONS</div></td>
                                            </tr>
                                            <template v-for="addon in item.addons">
                                                <template v-if="addon.hasOwnProperty('groupItems')">
                                                    <tr v-for="subItem in addon.groupItems" :class="{'item-cancelled': isItemCancelled(item)}">
                                                        <td>
                                                            <div>
                                                                <div class="item-name fw-normal">{{ addon.label }} - {{ subItem.label }}</div>
                                                            </div>
                                                        </td>
                                                        <td class="align-middle">
                                                            <div class="item-price fw-normal">{{ formatPrice(subItem.price, item.currency.symbol) }}</div>
                                                        </td>
                                                        <td class="align-middle">
                                                            <div class="item-quantity fw-normal">{{ subItem.total }}</div>
                                                        </td>
                                                        <td class="align-middle" :class="{'pe-4':isStandalone}">
                                                            <div class="item-price fw-normal">
                                                                {{ formatPrice(subItem.total_price, item.currency.symbol) }}
                                                            </div>
                                                        </td>
                                                        <td class="d-none"></td>
                                                    </tr>
                                                </template>
                                                <tr v-else :class="{'item-cancelled': isItemCancelled(item)}">
                                                    <td>
                                                        <div>
                                                            <div class="item-name fw-normal">{{ addon.label }}</div>
                                                        </div>
                                                    </td>
                                                    <td class="align-middle">
                                                        <div class="item-price fw-normal">{{ formatPrice(addon.price, item.currency.symbol) }}</div>
                                                    </td>
                                                    <td class="align-middle">
                                                        <div class="item-quantity fw-normal">{{ addon.total }}</div>
                                                    </td>
                                                    <td class="align-middle" :class="{'pe-4':isStandalone}">
                                                        <div class="item-price fw-normal">
                                                            {{ formatPrice(addon.total_price, item.currency.symbol) }}
                                                        </div>
                                                    </td>
                                                    <td class="d-none"></td>
                                                </tr>
                                            </template>
                                        </template>
                                    </template>
                                </tbody>
                            </table>

                            <div class="cart-summary">
                                <div class="summary-row">
                                    <span class="summary-label">Subtotal:</span>
                                    <span class="summary-value">{{ formatPrice(invoiceItems.subtotal, invoiceItems.currency.symbol) }}</span>
                                </div>
                                <div v-if="invoiceItems.discount" class="summary-row">
                                    <span class="summary-label">Promo Code{{ invoiceItems.items.length > 1 ? '' : ` (${invoiceItems.items[0].promocode})` }}:</span>
                                    <span class="summary-value text-secondary">-{{ formatPrice(invoiceItems.discount, invoiceItems.currency.symbol) }}</span>
                                </div>
                                <div class="summary-row">
                                    <span class="summary-label">Total:</span>
                                    <span class="summary-value">{{ formatPrice(invoiceItems.total, invoiceItems.currency.symbol) }}</span>
                                </div>
                                <template v-if="invoiceItems.payments && invoiceItems.payments.length > 0">
                                    <div v-for="(pay, pIdx) in invoiceItems.payments" :key="'pay-' + pIdx" class="summary-row">
                                        <span class="summary-label">Payment ({{ pay.date }}):</span>
                                        <span class="summary-value">{{ formatPrice(pay.total, invoiceItems.currency.symbol) }}</span>
                                    </div>
                                </template>
                                <template v-if="invoiceItems.refunds && invoiceItems.refunds.length > 0">
                                    <div v-for="(ref, rIdx) in invoiceItems.refunds" :key="'ref-' + rIdx" class="summary-row">
                                        <span class="summary-label">
                                            <div>Refund ({{ ref.date }}):</div>
                                            <div v-if="ref.note" class="fw-normal" style="font-size: 12px">{{ ref.note }}</div>
                                        </span>
                                        <span class="summary-value">{{ formatPrice(ref.total, invoiceItems.currency.symbol) }}</span>
                                    </div>
                                </template>
                                <div v-if="['Underpaid', 'Overpaid'].includes(invoiceItems.status)" class="summary-row">
                                    <span class="summary-label">Outstanding:</span>
                                    <span class="summary-value" :class="{'text-success-dark': invoiceItems.status === 'Overpaid', 'text-danger': invoiceItems.status === 'Underpaid'}">
                                        {{ (invoiceItems.status === 'Overpaid' ? '-' : '') + formatPrice(invoiceItems.outstanding, invoiceItems.currency.symbol) }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="card-body mx-3 invoice-footer">
                            <div class="row">
                                <div class="col-12 say-thank">
                                    <span class="fw-bold">Note: </span>
                                    <span>Thank you for choosing our tour services. We hope you had a wonderful experience and look forward to welcoming you again on your next adventure.</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="invoiceItems.note || invoiceItems.important_note || itemNotes.length" class="review-details mt-3 border border-danger">
                        <div class="section-header">
                            <div class="section-title text-white fw-semibold">{{ invoiceItems.important_note ? '[!] IMPORTANT note' : '[!] CANCELLATION INFORMATION' }}</div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-value">
                                <template v-if="invoiceItems.important_note">
                                    <div class="text-danger mb-2" v-html="invoiceItems.important_note"></div>
                                </template>
                                <div v-if="invoiceItems.note" class="text-danger" style="white-space: pre-wrap;" v-html="invoiceItems.note"></div>
                                <template v-if="!invoiceItems.note && !invoiceItems.important_note">
                                    <div v-for="(info, index) in itemNotes" :key="index" :class="{'mb-3': index < itemNotes.length - 1}">
                                        <div class="item-destination">{{ info.destinations }}</div>
                                        <div class="item-name">{{ info.name }}</div>
                                        <div v-if="info.description" class="item-description">{{ info.description }}</div>
                                        <div v-if="info.sub_description && !Array.isArray(info.sub_description)" class="item-sub-desc">{{ info.sub_description }}</div>
                                        <div v-else-if="info.sub_description && Array.isArray(info.sub_description) && info.sub_description.length" class="item-sub-desc">
                                            <template v-if="info.notes && Array.isArray(info.notes) && info.notes.length" v-for="note in info.notes">
                                                <span v-if="note"> {{ note }}</span>
                                            </template>
                                            <template v-for="sub_desc in info.sub_description">
                                                <span v-if="sub_desc"> {{ sub_desc }}</span>
                                            </template>
                                        </div>
                                        <div v-if="!(info.sub_description && Array.isArray(info.sub_description) && info.sub_description.length) && info.notes && Array.isArray(info.notes) && info.notes.length" class="item-sub-desc">
                                            <template v-for="note in info.notes">
                                                <span v-if="note"> {{ note }}</span>
                                            </template>
                                        </div>
                                        <div class="mt-2 text-danger">
                                            <strong>Reason:</strong><br>
                                            <span style="white-space: pre-wrap;" v-html="info.note"></span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <aside v-if="isStandalone" class="col-lg-12 col-xl-3" id="sidebar">
                    <div class="card shadow-sm border rounded mb-4 payment-detail">
                        <div class="card-header">
                            <div class="card-title mb-0 h6 text-black">
                                Payment
                            </div>
                        </div>
                        <div class="card-body">
                            <div>
                                <button
                                    type="button"
                                    class="btn btn-primary w-100 btn-checkout btn_1 full-width purchase"
                                    @click="handlePayment"
                                >
                                    Proceed to Payment
                                </button>
                            </div>
                        </div>
                    </div>
                </aside>
            </div>
        </template>
    </div>
</template>

<script>
import './css/invoice.scss';
import googleRecaptcha from "../../../../components/form/googleRecaptcha.vue";
import {formatHelper} from "../../../../utils/helpers/formatHelper.js";
import {utilHelper} from "../../../../utils/helpers/utilHelper.js";
import {elementHelper} from "../../../../utils/helpers/elementHelper.js";
import ApiService from "../../../../services/api.js";
import {errorHelper} from "../../../../utils/helpers/errorHelper.js";
import AjxService from "../../../../services/ajax.js";
import {gid, setgeo} from "../../../../utils/webRequest.js";
import {objectHelper} from "../../../../utils/helpers/objectHelper.js";

export default {
    name: "viewInvoice",
    components: {googleRecaptcha},
    props: {
        isStandalone: {
            type: Boolean,
            default: false
        },
        labelCaption: {
            type: String,
            default: 'Booking'
        },
        paymentId: {
            type: [null, String],
            default: null
        },
        logo: {
            type: [null, String],
            default: null
        },
        shortName: {
            type: [null, String],
            default: null
        },
        shortNameColor: {
            type: [null, String],
            default: null
        }
    },
    data() {
        return {
            isMounted: false,
            isGoogleScriptLoaded: false,
            loaded: false,
            invoiceItems: {},
            paymentWindowInterval: null,
            paymentSessionId: null,
            paymentSessionMac: null
        }
    },
    computed: {
        loggedIn() {
            return this.$store.getters["auth/loggedIn"];
        },
        itemNotes() {
            if (this.invoiceItems.items && this.invoiceItems.items.length > 1) {
                return this.invoiceItems.items.filter(item => item.payment_status === 'Cancelled' && item.note);
            }
            return [];
        }
    },
    mounted() {
        this.isMounted = true;
        this.$nextTick(() => {
            this.setActivated();
            this.isMounted = false;
        });
    },
    activated() {
        if(!this.isMounted) {
            this.setActivated();
        }
    },
    deactivated() {
        this.setDeactivated();
    },
    unmounted() {
        this.setDeactivated();
    },
    methods: {
        setActivated() {
            this.loaded = false;
            if (this.isGoogleScriptLoaded || !this.isStandalone) {
                this.getInvoiceItems();
            }
        },
        setDeactivated() {
            this.loaded = false;
            this.invoiceItems = {};
            this.cleanupPaymentWindow();
        },
        formatPrice(number, symbol = '') {
            const price = (typeof (number || 0)) === 'number' ? (number || 0) : (!isNaN(parseFloat(number)) ? parseFloat(number) : 0);
            if(price) {
                return symbol + formatHelper.formatNumber(price, (symbol.trim().toLowerCase()==='rp'?'id-ID':'en-US'));
            }
            return '-';
        },
        isItemCancelled(item) {
            return (this.invoiceItems.items || []).length > 1 &&
                item.payment_status === 'Cancelled' &&
                item.payment_status !== this.invoiceItems.status;
        },
        async googleScriptLoaded() {
            if (this.isStandalone) {
                let geo = await gid();
                if (!geo) {
                    try {
                        const geoData = await setgeo();
                        geo = geoData.i;
                    } catch (error) {
                    }
                }
                if(geo) {
                    const isGuest = window.localStorage.getItem("guest") === "isGuest";
                    if(!isGuest) {
                        await this.$store.dispatch("auth/getAuthUser").then(response => {
                        }).finally(() => {
                            this.getInvoiceItems();
                        });
                    } else {
                        await this.getInvoiceItems();
                    }
                }
            } else {
                await this.getInvoiceItems();
            }
        },
        async getInvoiceItems(_payload= {}, _loader = false) {
            const loaderId = utilHelper.getUniqueId();
            const endpoint = `/booking/payment/${this.paymentId}/get`;
            let payload = _payload;
            let element = null;

            if (this.loggedIn) {
                if (!this.isStandalone) {
                    payload.staff = true;
                    element = this.$el.closest(_loader ? '.modal-content' : '.modal-body');
                    element.classList.add('position-relative');
                    elementHelper.loader.show(loaderId, this.$el.closest('.modal-body'), 36, 36, 'dots');
                } else if(_loader) {
                    elementHelper.loader.show(loaderId, element, 36, 36, 'dots');
                }
                ApiService.post(endpoint, payload).then(response => {
                    if(!objectHelper.isEmptyObject(response.data)) {
                        this.invoiceItems = response.data;
                    } else {
                        this.invoiceItems = {};
                    }
                }).catch(error => {
                    this.invoiceItems = {};
                    if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                        errorHelper.error(error);
                    }
                }).finally(() => {
                    if (!this.isStandalone || _loader) {
                        elementHelper.loader.hide(loaderId);
                    }
                    if(element) {
                        element.classList.remove('position-relative');
                    }
                    this.loaded = true;
                });
            } else {
                await this.$refs.googleRecaptcha.verify().then(async token => {
                    payload.token = token;
                    if(_loader) {
                        elementHelper.loader.show(loaderId, this.$el.closest('.modal-body'), 36, 36, 'dots');
                    }
                    AjxService.post(endpoint, payload).then(response => {
                        if(!objectHelper.isEmptyObject(response.data)) {
                            this.invoiceItems = response.data;
                        } else {
                            this.invoiceItems = {};
                        }
                    }).catch(error => {
                        this.invoiceItems = {};
                        if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                            errorHelper.error(error);
                        }
                    }).finally(() => {
                        if (_loader) {
                            elementHelper.loader.hide(loaderId);
                        }
                        if(element) {
                            element.classList.remove('position-relative');
                        }
                        this.loaded = true;
                    })
                });
            }
        },


        async handlePayment() {
            // Calculate center position for popup
            const width = 600;
            const height = 800;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);

            // Window features
            const windowFeatures = `width=${width},height=${height},left=${left},top=${top},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no,copyhistory=no`;

            // Open a blank window immediately to avoid Safari's popup blocker
            // This must be done synchronously in the click event handler
            const paymentWindow = window.open('about:blank', 'ANZPaymentWindow', windowFeatures);

            try {
                // Get hosted checkout session from backend
                const sessionData = await this.createHostedCheckoutSession();

                if (!sessionData || !sessionData.hostedCheckoutUrl) {
                    if (paymentWindow) paymentWindow.close();
                    return;
                }

                // Check if popup was blocked
                if (!paymentWindow || paymentWindow.closed || typeof paymentWindow.closed === 'undefined') {
                    return;
                }

                // Set the URL to the actual hosted checkout URL
                paymentWindow.location.href = sessionData.hostedCheckoutUrl;

                // Focus the popup window
                paymentWindow.focus();

                // Store session ID for status checking
                this.paymentSessionId = sessionData.hostedCheckoutId;
                this.paymentSessionMac = sessionData.returnMac;

                // Listen for window close
                const checkWindowClosed = setInterval(() => {
                    if (paymentWindow.closed) {
                        clearInterval(checkWindowClosed);
                        this.onPaymentWindowClosed();
                    }
                }, 500);

                // Store reference for cleanup
                this.paymentWindowInterval = checkWindowClosed;

            } catch (error) {
                if (paymentWindow) paymentWindow.close();
                console.error('Payment initialization error:', error);
            }
        },

        onPaymentWindowClosed() {
            if (this.paymentSessionId) {
                this.checkPaymentStatus();
            }
            this.cleanupPaymentWindow();
        },

        async createHostedCheckoutSession() {
            const loaderId = utilHelper.getUniqueId();
            const endpoint = `/booking/payment/${this.paymentId}/create-session`;

            try {
                elementHelper.loader.show(loaderId, null, 36, 36, 'dots');

                let response;
                if (this.loggedIn) {
                    const payload = !this.isStandalone ? { staff: true } : {};
                    response = await ApiService.post(endpoint, payload);
                } else {
                    const token = await this.$refs.googleRecaptcha.verify();
                    response = await AjxService.post(endpoint, { token });
                }

                return response.data;
            } catch (error) {
                if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError')) {
                    errorHelper.error(error);
                }
                throw error;
            } finally {
                elementHelper.loader.hide(loaderId);
            }
        },

        async checkPaymentStatus() {
            const loaderId = utilHelper.getUniqueId();
            const endpoint = `/booking/payment/${this.paymentId}/check-status`;
            const payload = {
                hostedCheckoutId: this.paymentSessionId,
                returnMac: this.paymentSessionMac
            };

            try {
                elementHelper.loader.show(loaderId, null, 36, 36, 'dots');
                let response;
                if (this.loggedIn) {
                    const apiPayload = !this.isStandalone ? { ...payload, staff: true } : payload;
                    response = await ApiService.post(endpoint, apiPayload);
                } else {
                    const token = await this.$refs.googleRecaptcha.verify();
                    response = await AjxService.post(endpoint, { ...payload, token });
                }

                if (response.data && response.data.status) {
                    if (['PAYMENT_CREATED', 'PAID'].includes(response.data.status.toUpperCase()) && response.data.hasOwnProperty('redirect_url')) {
                        window.location.href = response.data.redirect_url;
                    } else {
                        await this.getInvoiceItems({}, true);
                    }
                }
            } catch (error) {
                if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError')) {
                    errorHelper.error(error);
                }
            } finally {
                elementHelper.loader.hide(loaderId);
            }
        },

        cleanupPaymentWindow() {
            if (this.paymentWindowInterval) {
                clearInterval(this.paymentWindowInterval);
                this.paymentWindowInterval = null;
            }
            this.paymentSessionId = null;
            this.paymentSessionMac = null;
        },

        isVehicle(item) {
            if(item.hasOwnProperty('isVehicle')) {
                return item.isVehicle;
            }
            return false;
        },
        isGroup(item) {
            if(item.hasOwnProperty('isGroup')) {
                return item.isGroup;
            }
            return false;
        },
        isHasRoom(item) {
            if(item.hasOwnProperty('isHasRoom')) {
                return item.isHasRoom;
            }
            return false;
        },
        hasPickup(item) {
            if(item.hasOwnProperty('pickup')) {
                return !objectHelper.isEmptyObject(item.pickup);
            }
            return false;
        },
        hasDropOff(item) {
            if(item.hasOwnProperty('dropOff')) {
                return !objectHelper.isEmptyObject(item.dropOff);
            }
            return false;
        },
        hasAddons(item) {
            if(item.hasOwnProperty('addons')) {
                return Array.isArray(item.addons) && item.addons.length > 0;
            }
            return false;
        },
        hasItems(item) {
            if(item.hasOwnProperty('items')) {
                return Array.isArray(item.items) && item.items.length > 0;
            }
            return false;
        },
        locationServiceInfo(item) {
            const _time = (item.time || '') ? `<span class="clock">${item.time}</span>` : '';
            const _mapLatLong = (item.latitude || '') && (item.longitude || '') ? `<span class="meet-point"><a href="https://www.google.com/maps/search/?api=1&query=${item.latitude},${item.longitude}" target="_blank">Meeting Point (click)</a></span>` : '';
            const _meetPoint = (item.url_map || '') ? `<span class="meet-point"><a href="${item.url_map}" target="_blank">Meeting Point (click)</a></span>` : (_mapLatLong);

            if(_time || _meetPoint) {
                return `
                        ${_time}
                        ${_meetPoint}
                    `;
            }

            return '';
        },
        isReturnDifferentDay(item) {
            return item.ticketType === 'Return on a Different Day';
        },
        isReturnDifferentDPTP(item) {
            return item.ticketType === 'Return on a Different DPTP';
        },
        isDepartureTicket(item) {
            return item.ticketType === 'One Way Departure';
        },
        isReturnTicket(item) {
            return item.ticketType === 'One Way Return';
        },
        isPointToPointTicket(item) {
            return item.ticketType === 'Point To Point';
        },
        isHasReturnPickup(item) {
            return !objectHelper.isEmptyObject(item.returnPickup);
        }
    }
}
</script>

<style scoped>

</style>
